import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import Router from "routing/Router";
import { ErrorBoundaryApp } from "components/common/error";
import CacheBuster from "components/common/utils/CacheBuster";
import { GlobalStyle, theme } from "theme";
import Chamaeleon from "utils/chamaeleon";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return (
          <ErrorBoundaryApp>
            <GlobalStyle />
            <Chamaeleon />
            <ThemeProvider theme={theme}>
              <BrowserRouter>
                <Router />
              </BrowserRouter>
            </ThemeProvider>
            <ToastContainer theme="colored" autoClose={2000} />
          </ErrorBoundaryApp>
        );
      }}
    </CacheBuster>
  );
}

export default App;
